module.exports = __webpack_public_path__ + "static/media/stories_2x.8b63544b.png";